import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const diffusionSchedulerComponent: ComponentDef = {
  id: 'diffusion-scheduler',
  name: 'Diffusion Scheduler',
  description: 'Iteratively denoise latents using a learned model and a noise schedule. Supports DDPM, DDIM, Euler, and DPM++ update rules.',
  category: 'multimodal',
  params: [
    { name: 'n_patches', label: 'Latent patches', type: 'number', default: 256, min: 1, max: 1024, step: 1 },
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 768, min: 64, max: 4096, step: 64 },
    { name: 'steps', label: 'Timesteps', type: 'number', default: 50, min: 1, max: 1000, step: 1 },
    {
      name: 'scheduler',
      label: 'Scheduler',
      type: 'select',
      default: 'ddpm',
      options: [
        { label: 'DDPM (stochastic)', value: 'ddpm' },
        { label: 'DDIM (deterministic)', value: 'ddim' },
        { label: 'Euler (flow-based)', value: 'euler' },
        { label: 'DPM++ 2M (multi-step)', value: 'dpm++' }
      ]
    }
  ],
  buildGraph: (params) => {
    const n_patches = Number(params.n_patches);
    const d_model = Number(params.d_model);
    const steps = Number(params.steps);
    const scheduler = String(params.scheduler || 'ddpm');

    const g = new GraphBuilder();
    g.input('z_t', [n_patches, d_model]);
    g.input('t', [1]);

    g.linear('patch_embed', 'z_t', [d_model, d_model]);
    g.add('cond', 'patch_embed', 't');
    g.scale('schedule', 'cond', `${scheduler.toUpperCase()} schedule (${steps})`);
    g.linear('pred_noise', 'schedule', [d_model, d_model]);

    if (scheduler === 'dpm++') {
      // Multi-step: uses previous noise estimate as well
      g.input('prev_noise', [n_patches, d_model]);
      g.add('z_prev', 'z_t', 'pred_noise');
      g.add('z_prev2', 'z_prev', 'prev_noise');
      g.output('out', 'z_prev2');
    } else if (scheduler === 'euler') {
      g.add('z_next', 'z_t', 'pred_noise');
      g.output('out', 'z_next');
    } else {
      // DDPM / DDIM single-step update
      g.add('z_prev', 'z_t', 'pred_noise');
      g.output('out', 'z_prev');
    }

    return g.build();
  }
};
